import { render } from "./Button1.vue?vue&type=template&id=0df0deb6"
import script from "./Button1.vue?vue&type=script&lang=js"
export * from "./Button1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__